export const MAX_CHAT_NAME_LENGTH = 255;

export function getSanitizedChatName(name: string): string {
  return name.trim();
}

export function getChatNameValidationMessage(name: string): string | null {
  const trimmedName = getSanitizedChatName(name);

  if (trimmedName.length > MAX_CHAT_NAME_LENGTH) {
    return `Chat name must be ${MAX_CHAT_NAME_LENGTH} characters or fewer`;
  }

  if (trimmedName.length === 0) {
    return 'Chat name cannot be empty';
  }

  return null;
}